import gql from "graphql-tag";

export const CREATE_INSURANCE_PLAN = gql`
  mutation AddInsurancePlan($data: InsurancePlanDataInput) {
    addInsurancePlan(data: $data) {
      id
      internal
      risk
    }
  }
`;

export const UPDATE_INSURANCE_PLAN = gql`
  mutation UpdateInsurancePlan(
    $data: InsurancePlanDataInput
    $where: InsurancePlanWhereInput
  ) {
    updateInsurancePlan(data: $data, where: $where) {
      id
    }
  }
`;

export const DELETE_INSURANCE_PLAN = gql`
  mutation DeleteInsurancePlan($where: InsurancePlanWhereInput) {
    deleteInsurancePlan(where: $where) {
      id
    }
  }
`;

export const DUPLICATE_INSURANCE_PLAN = gql`
  mutation DuplicateInsurancePlan(
    $where: InsurancePlanWhereInput
    $data: InsurancePlanDataInput
  ) {
    duplicateInsurancePlan(where: $where, data: $data) {
      id
    }
  }
`;

export const VALIDATE_INSURANCE_PLAN_IMPORT = gql`
  mutation ValidateInsurancePlanImport(
    $data: InsurancePlanImportValidateInput
  ) {
    validateInsurancePlanImport(data: $data) {
      valid
      errors {
        key
        params
      }
      warnings
      mapping
      autoMapping
      headers
      totalRows
      preview
      columnSamples
      fields {
        key
        required
        validation
      }
    }
  }
`;

export const EXECUTE_INSURANCE_PLAN_IMPORT = gql`
  mutation ExecuteInsurancePlanImport($data: InsurancePlanImportExecuteInput) {
    executeInsurancePlanImport(data: $data) {
      success
      created
      updated
      skipped
      totalRows
      strategy
      errors {
        key
        params
      }
      insurancePlans {
        id
        identifier
        name
      }
    }
  }
`;

export const VALIDATE_INSURANCE_PLAN_PARAMS_IMPORT = gql`
  mutation ValidateInsurancePlanParamsImport(
    $data: InsurancePlanImportValidateInput
  ) {
    validateInsurancePlanParamsImport(data: $data) {
      valid
      errors {
        key
        params
      }
      warnings
      mapping
      autoMapping
      headers
      totalRows
      preview
      columnSamples
      fields {
        key
        required
        validation
      }
    }
  }
`;

export const EXECUTE_INSURANCE_PLAN_PARAMS_IMPORT = gql`
  mutation ExecuteInsurancePlanParamsImport(
    $data: InsurancePlanImportExecuteInput
  ) {
    executeInsurancePlanParamsImport(data: $data) {
      success
      created
      updated
      skipped
      totalRows
      errors {
        key
        params
      }
      insurancePlans {
        id
        identifier
        name
      }
    }
  }
`;

export const UPLOAD_INSURANCE_PLAN_DOCUMENTS = gql`
  mutation UploadInsurancePlanDocuments($data: InsurancePlanDocsUploadInput) {
    uploadInsurancePlanDocuments(data: $data) {
      success
      uploaded
      failed
      files {
        filename
        type
        attachmentId
        success
        error
      }
      errors {
        key
        params
      }
    }
  }
`;

export const VALIDATE_INSURANCE_PLAN_DOCS_LINK = gql`
  mutation ValidateInsurancePlanDocsLink(
    $data: InsurancePlanImportValidateInput
  ) {
    validateInsurancePlanDocsLink(data: $data) {
      valid
      errors {
        key
        params
      }
      warnings
      mapping
      autoMapping
      headers
      totalRows
      preview
      columnSamples
      fields {
        key
        required
        validation
      }
    }
  }
`;

export const EXECUTE_INSURANCE_PLAN_DOCS_LINK = gql`
  mutation ExecuteInsurancePlanDocsLink(
    $data: InsurancePlanImportExecuteInput
  ) {
    executeInsurancePlanDocsLink(data: $data) {
      success
      created
      updated
      skipped
      totalRows
      errors {
        key
        params
      }
      insurancePlans {
        id
        identifier
        name
      }
    }
  }
`;

export const VALIDATE_INSURANCE_PLAN_YAML_IMPORT = gql`
  mutation ValidateInsurancePlanYamlImport(
    $data: InsurancePlanYamlImportInput
  ) {
    validateInsurancePlanYamlImport(data: $data) {
      valid
      errors {
        key
        params
      }
      warnings
      totalPlans
      newPlans
      existingPlans
      plans {
        identifier
        name
        isStandalone
        isNew
        coverageCount
        moduleCount
        documentCount
        warnings
        details
      }
    }
  }
`;

export const EXECUTE_INSURANCE_PLAN_YAML_IMPORT = gql`
  mutation ExecuteInsurancePlanYamlImport($data: InsurancePlanYamlImportInput) {
    executeInsurancePlanYamlImport(data: $data) {
      success
      created
      updated
      skipped
      totalPlans
      strategy
      errors {
        key
        params
      }
      insurancePlans {
        id
        identifier
        name
      }
    }
  }
`;

const products = {
  CREATE_INSURANCE_PLAN,
  UPDATE_INSURANCE_PLAN,
  VALIDATE_INSURANCE_PLAN_YAML_IMPORT,
  EXECUTE_INSURANCE_PLAN_YAML_IMPORT,
  DELETE_INSURANCE_PLAN,
  DUPLICATE_INSURANCE_PLAN,
  VALIDATE_INSURANCE_PLAN_IMPORT,
  EXECUTE_INSURANCE_PLAN_IMPORT,
  VALIDATE_INSURANCE_PLAN_PARAMS_IMPORT,
  EXECUTE_INSURANCE_PLAN_PARAMS_IMPORT,
  UPLOAD_INSURANCE_PLAN_DOCUMENTS,
  VALIDATE_INSURANCE_PLAN_DOCS_LINK,
  EXECUTE_INSURANCE_PLAN_DOCS_LINK,
};

export default products;
